import React from 'react';
import Icon from './Icon';

const PlusIcon = (props) => (
    <Icon {...props}>
        <path d="M6 12H18M12 6V18" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default PlusIcon;